var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7421 17.25L13.5258 16.0933L13.0522 12.4621L9.86069 10.7964L8.99609 19.3692L6.33652 17.9812L5.07346 8.29794L1.17276 6.26214C0.685171 6.00766 0.358376 5.6162 0.192372 5.08776C0.0263679 4.55932 0.0706037 4.05131 0.32508 3.56372C0.579556 3.07613 0.971014 2.74934 1.49945 2.58333C2.02789 2.41733 2.53591 2.46157 3.02349 2.71604L6.9242 4.75185L15.5902 0.250692L18.2498 1.63874L11.7114 7.25034L14.9029 8.916L18.1527 7.22807L20.369 8.38478L16.7258 12.1234L15.7421 17.25Z",
    fill: "#38C23C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.db793675fdafc9f59b49b035085e2f98.svg";
export { ForwardRef as ReactComponent };